import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { faEnvelopeDot, faIdCard, faLink } from '@fortawesome/pro-duotone-svg-icons';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { RegistrationStatusService } from './registration-status.service';
import { EnvironmentConfig } from '../config/environment.config';
import { BannerModel } from '../models/banner.model';

@Injectable({
  providedIn: 'root'
})
export class BannersService {
  banners$: Observable<BannerModel[]>;

  private bannersEvent$ = new BehaviorSubject<void>(undefined);

  private profile: BannerModel = new BannerModel(faIdCard, 'MYOPINION.BANNER.PROFILE.DESCRIPTION', {
    text: 'MYOPINION.BANNER.PROFILE.BTN_TEXT'
  });
  private email: BannerModel = new BannerModel(faEnvelopeDot, 'MYOPINION.BANNER.EMAIL.DESCRIPTION', {
    text: 'MYOPINION.BANNER.EMAIL.BTN_TEXT',
    link: ['/check-email-verification']
  });
  private referal: BannerModel = new BannerModel(faLink, 'MYOPINION.BANNER.INVITE_FRIENDS.DESCRIPTION', {
    text: 'MYOPINION.BANNER.INVITE_FRIENDS.BTN_TEXT',
    link: ['/invite-friends']
  });

  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient,
    private registrationStatusService: RegistrationStatusService
  ) {
    this.initBanners();
  }

  refreshBanners(): void {
    this.bannersEvent$.next();
  }

  private initBanners(): void {
    this.banners$ = this.bannersEvent$.pipe(
      switchMap(() => forkJoin([this.registrationStatusService.isEmailVerified(), this.isAllowedToInviteFriends(), this.registrationStatusService.getPendingProfileSurvey()])),
      map(([isEmailVerified, isAllowedToInviteFriends, pendingProfileSurvey]) => {
        const banners: BannerModel[] = [];
        if (!isEmailVerified) {
          banners.push(this.email);
        }
        if (pendingProfileSurvey.id) {
          this.profile.button.link = ['/survey', pendingProfileSurvey.id];
          banners.push(this.profile);
        }
        if (isAllowedToInviteFriends) {
          banners.push(this.referal);
        }

        return banners;
      })
    );
  }

  private isAllowedToInviteFriends(): Observable<boolean> {
    return this.http.get<{ referralCode: string }>(`${this.environment.endPoint}panel-member`).pipe(
      map((panelMember: { referralCode: string }) => !!panelMember.referralCode),
      take(1)
    );
  }
}
